// Generic breadcrumb — renders a canonical path as <nav> › <ol>.
// Items with an onClick are clickable link-buttons; items without (typically the
// last, current page) render as plain text flagged aria-current="page".
// The component is intentionally dumb: it knows nothing about records or routing.
export default function Breadcrumb({ items = [], className = '', ...rest }) {
  const crumbs = items.filter(Boolean)
  return (
    <nav aria-label="Breadcrumb" className={`cn-breadcrumb ${className}`.trim()} {...rest}>
      <ol className="cn-breadcrumb-list">
        {crumbs.map((item, i) => {
          const isLast = i === crumbs.length - 1
          return (
            <li key={i} className="cn-crumb">
              {item.onClick
                ? <button type="button" className="cn-crumb-link" onClick={item.onClick}>{item.label}</button>
                : <span className="cn-crumb-current" {...(isLast ? { 'aria-current': 'page' } : {})}>{item.label}</span>}
              {i < crumbs.length - 1 && <span className="cn-crumb-sep" aria-hidden="true">›</span>}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
